<template>
  <div class="box-qtd">
    <button class="btn botao-qtd" type="button" @click="change(false)" :class="{'disabled' : qtd === 1}">
      <i class="fa fa-minus"></i>
    </button>
    <div class="qtd-output text-dark"><b>{{qtd}}</b></div>
    <button class="btn botao-qtd" type="button" @click="change(true)" :class="{'disabled' : qtd == max}">
      <i class="fa fa-plus"></i>
    </button>
  </div>
</template>

<script>
  export default {
    name: "quantidade",
    props: ["qtdInicial","item","max"],
    data () {
      return {
        qtd: 1,
      }
    },

    methods: {
      change(tipo) {
        if (!tipo) {
          this.qtd = this.qtd > 1 ? --this.qtd : 1;

        } else if (this.qtd < this.max) {
          this.qtd++;
        }

        this.$emit('change', this.qtd);
      }
    },

    mounted() {
      this.qtd = this.qtdInicial > 0 ? parseInt(this.qtdInicial) : 1;
    }
  }
</script>

<style scoped>
</style>
